var map = {
	"./at/de/engagementRings_FAQPage.json": 2141,
	"./at/de/engagementRings_WebPage.json": 2142,
	"./at/de/weddingRings_FAQPage.json": 2143,
	"./at/de/weddingRings_WebPage.json": 2144,
	"./at/en/engagementRings_FAQPage.json": 2145,
	"./at/en/weddingRings_FAQPage.json": 2146,
	"./ch/de/engagementRings_FAQPage.json": 2147,
	"./ch/de/engagementRings_WebPage.json": 2148,
	"./ch/de/weddingRings_FAQPage.json": 2149,
	"./ch/de/weddingRings_WebPage.json": 2150,
	"./ch/en/engagementRings_FAQPage.json": 2151,
	"./ch/en/weddingRings_FAQPage.json": 2152,
	"./ch/fr/engagementRings_FAQPage.json": 2153,
	"./ch/fr/weddingRings_FAQPage.json": 2154,
	"./de/de/engagementRings_FAQPage.json": 2155,
	"./de/de/engagementRings_WebPage.json": 2156,
	"./de/de/index_Organization.json": 2157,
	"./de/de/shopsDetails_berlin.json": 2158,
	"./de/de/weddingRings_FAQPage.json": 2159,
	"./de/de/weddingRings_WebPage.json": 2160,
	"./de/en/engagementRings_FAQPage.json": 2161,
	"./de/en/weddingRings_FAQPage.json": 2162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2140;